/* Atlas Rug Pads — mobile hero cleanup only.
   <=749px only. Desktop Canva rendering is preserved exactly.
   Uses the approved cover crop for clearer rug-pad visibility. */
(() => {
  const MOBILE_MAX = 749;
  const ASPECT = 2.25;
  let applying = false, observer = null, resizeTimer = null;
  const rect = (el) => (el ? el.getBoundingClientRect() : null);
  const originals = new Map();

  function remember(el) {
    if (!el || originals.has(el)) return;
    originals.set(el, el.getAttribute('style'));
  }

  function restoreDesktop() {
    originals.forEach((style, el) => {
      if (!el?.isConnected) return;
      if (style == null) el.removeAttribute('style');
      else el.setAttribute('style', style);
    });
    originals.clear();
  }

  function largestMedia(hero) {
    return [...hero.querySelectorAll('img,video')]
      .filter((el) => {
        const r = rect(el);
        return r && r.width > 120 && r.height > 80;
      })
      .sort((a, b) => {
        const ar = rect(a), br = rect(b);
        return br.width * br.height - ar.width * ar.height;
      })[0] || null;
  }

  function applyFix() {
    if (applying) return;
    const root = document.querySelector('#root');
    if (!root) return;

    applying = true;
    if (observer) observer.disconnect();
    try {
      if (window.innerWidth > MOBILE_MAX) {
        restoreDesktop();
        return;
      }

      const hero = root.querySelector('section');
      if (!hero) return;
      const media = largestMedia(hero);
      if (!media) return;

      const w = hero.parentElement?.clientWidth || root.clientWidth || document.documentElement.clientWidth;
      const h = `${w / ASPECT}px`;

      remember(hero);
      hero.style.setProperty('height', h, 'important');
      hero.style.setProperty('min-height', h, 'important');
      hero.style.setProperty('max-height', h, 'important');
      hero.style.setProperty('overflow', 'hidden', 'important');
      hero.style.setProperty('position', 'relative', 'important');
      hero.style.setProperty('background', '#ffffff', 'important');

      let el = media.parentElement;
      while (el && el !== hero.parentElement) {
        if (hero.contains(el)) {
          remember(el);
          el.style.setProperty('width', '100%', 'important');
          el.style.setProperty('height', h, 'important');
          el.style.setProperty('min-height', h, 'important');
          el.style.setProperty('max-height', h, 'important');
          el.style.setProperty('top', '0', 'important');
          el.style.setProperty('left', '0', 'important');
          el.style.setProperty('transform', 'none', 'important');
          el.style.setProperty('overflow', 'hidden', 'important');
          el.style.setProperty('background', '#ffffff', 'important');
        }
        if (el === hero) break;
        el = el.parentElement;
      }

      remember(media);
      media.style.setProperty('width', '100%', 'important');
      media.style.setProperty('height', '100%', 'important');
      media.style.setProperty('position', 'absolute', 'important');
      media.style.setProperty('top', '0', 'important');
      media.style.setProperty('left', '0', 'important');
      media.style.setProperty('transform', 'none', 'important');
      media.style.setProperty('object-fit', 'cover', 'important');
      media.style.setProperty('object-position', 'center center', 'important');
      media.style.setProperty('background', '#ffffff', 'important');
    } finally {
      if (observer) observer.observe(root, { childList: true, subtree: true });
      applying = false;
    }
  }

  function repeat() {
    [0, 100, 250, 500, 900, 1500, 2500, 4000].forEach((d) =>
      setTimeout(() => requestAnimationFrame(applyFix), d)
    );
  }

  function init() {
    repeat();
    const root = document.querySelector('#root');
    if (root && !observer) {
      observer = new MutationObserver(() => {
        if (!applying) requestAnimationFrame(applyFix);
      });
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('load', repeat, { once: true });
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(repeat, 100);
  });
})();
